import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import SegmentDetails from './SegmentDetails';
import TechnicalStop from './TechnicalStop';
import {formatDuration} from '../common';

const getAirportDetails = ({location, datetime}) => {
  return {
    ...location,
    datetime
  };
};

const Segment = ({segment, translations}) => {
  const {
    isLast,
    hasTechnicalStop,
    stopDuration,
    differentAirport,
    route: {departure, arrival, technicalStop}
  } = segment;
  const {
    stopDuration: stopDurationTitle,
    differentAirportSegmentsText,
    formatNextDayArrival,
    time
  } = translations;

  return (
    <Fragment>{formatNextDayArrival}
      {
        <SegmentDetails
          segment={segment}
          depAirport={getAirportDetails(departure)}
          arrAirport={getAirportDetails(hasTechnicalStop ? technicalStop[0].arrival : arrival)}
          hasTechnicalStop={hasTechnicalStop}
          translations={translations}
        />
      }
      {
        hasTechnicalStop && <TechnicalStop
          segment={segment}
          depAirport={getAirportDetails(technicalStop[0].departure)}
          arrAirport={getAirportDetails(arrival)}
          stopDuration={technicalStop[0].duration}
          translations={translations}
        />
      }
      {
        !isLast &&
          <div className="grid flight-stop">
            <div className="grid-item-7-10 offset-3-10 result-details-stop-info">
              <div className="p-2 bg-light mb-3 text-small leading-small">
                {stopDurationTitle}:&nbsp;
                <strong className="d-block d-sm-inline">{formatDuration(stopDuration, time)}</strong>
              </div>
              {
                differentAirport &&
                  <div className="text-danger text-small mb-3">
                    <i className="icon icon-t-warning-e" />
                    &nbsp;{differentAirportSegmentsText}
                  </div>
              }
            </div>
          </div>
      }
    </Fragment>
  );
};

Segment.propTypes = {
  segment: PropTypes.object.isRequired,
  translations: PropTypes.object.isRequired
};

export default Segment;
